<template>
  <div>
    <!--    <breadcrumb :routerList="[{to:'loudnew/LoudMain',title:'信息漏斗'}]"/>-->
    <Breadtabsheader />
    <div class="h-content">

      <!--查询表单-->
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="需求名称">
                <el-input v-model="q.projectName"></el-input>
              </el-form-item>
              <el-form-item label="用户名称">
                <el-input v-model="q.customerName"></el-input>
              </el-form-item>
              <el-form-item label="经销商名称">
                <el-input v-model="q.agentName"></el-input>
              </el-form-item>
              <el-form-item label="报单人">
                <el-input v-model="q.cuname"></el-input>
              </el-form-item>
            </div>
            <el-collapse-transition>
              <div v-show="isScreen">
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="渠道">
                    <brselect category="sales_region" :v="q.customerChannel" v-model="q.customerChannel" :clearable="true" style="width:100%" />
                  </el-form-item>
                  <el-form-item label="订单分类" style="width: 270px">
                    <brselect category="message_type" :v="q.probjectSorts" v-model="q.probjectSorts" :clearable="true" style="width:100%" />
                  </el-form-item>
                  <el-form-item label="节点">
                    <brselect category="xinxi_jiedian_all" :v="q.statusR" v-model="q.statusR" :clearable="true" style="width:100%" />
                  </el-form-item>
                  <el-form-item label="链群">
                    <brselect category="xsyb_lianqun" :v="q.lianqun" v-model="q.lianqun" :clearable="true" style="width:100%" />
                  </el-form-item>

                </div>
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="产品大类">
                    <el-input v-model="q.proLevelOne"></el-input>
                  </el-form-item>
                  <el-form-item label="产品中类" class="h-elformWrap-1">
                    <el-input v-model="q.proLevelTwo"></el-input>
                  </el-form-item>
                  <el-form-item class="h-elformWrap-1" label="预计下单时间">
                    <el-col>
                      <el-date-picker type="daterange" v-model="expOnlineDateTimes" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" width="100%">
                      </el-date-picker>
                    </el-col>
                  </el-form-item>
                </div>
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="产品类型">
                    <brselect category="product_type" :v="q.proType" v-model="q.proType" :clearable="true" style="width:100%" />
                  </el-form-item>
                  <el-form-item label="漏斗状态">
                    <el-select v-model="q.status" :clearable="true">
                      <el-option label="正常" value="0"></el-option>
                      <el-option label="审批中" value="1"></el-option>
                      <el-option label="暂存" value="2"></el-option>
                      <el-option label="驳回" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item class="h-elformWrap-1" label="预计转化时间">
                    <el-col>
                      <el-date-picker type="daterange" v-model="itemtimes" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" width="100%">
                      </el-date-picker>
                    </el-col>
                  </el-form-item>
                </div>
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="部门" style="width: 20%">
                    <el-input v-model="q.deptName"></el-input>
                  </el-form-item>
                  <el-form-item label="销售人员" style="width: 20%">
                    <el-input v-model="q.salesman"></el-input>
                  </el-form-item>
                  <el-form-item label="漏斗编号">
                    <el-input v-model="q.funnelCode"></el-input>
                  </el-form-item>
                  <el-form-item class="h-elformWrap-1" label="报单日期" style="width: 30%">
                    <el-col>
                      <el-date-picker type="daterange" v-model="times" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" width="100%">
                      </el-date-picker>
                    </el-col>
                  </el-form-item>

                </div>
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="漏斗创建时间" style="width: 50%;">
                    <el-date-picker placeholder="请选择" v-model="q.date1" clearable type="date" value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <span class="w-time-to">至</span>
                    <el-date-picker placeholder="请选择" v-model="q.date2" clearable type="date" value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>
            </el-collapse-transition>
            <div class="l-screenBox">
              <div class="l-screen" @click="collapseChange">
                <img :src="isScreen?closeScreen:drawScreen" alt="">
                <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
              </div>
              <div class="l-retrieval">
                <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="createNew">
                  新建目标
                </el-button>
                <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="imgfalse3" v-auth="'order_loud'">
                  一键生单
                </el-button>
              </div>
            </div>
          </el-form>
        </div>
      </div>

      <!--展示表格-->
      <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
        <el-table ref="ddtable" @selection-change="handleSelectionChange" :data="tableData" max-height="560" stripe :span-method="objectSpanMethod" style="width: 100%" :border="true">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column type="index" label="序号" width="55">
          </el-table-column>
          <el-table-column prop="subNumber" label="子序号" width="75">
          </el-table-column>
          <el-table-column prop="funnelCode" label="漏斗信息编号" width="140">
          </el-table-column>

          <el-table-column prop="proState" label="状态" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.proState == 1 ">
                未转化
              </span>
              <span v-if="scope.row.proState == 2 ">
                部分已转化
              </span>
              <span v-if="scope.row.proState == 3 ">
                已转化
              </span>
              <span v-if="scope.row.proState == 4 ">
                已丢标
              </span>
            </template>
          </el-table-column>

          <el-table-column prop="proState" label="漏斗来源" width="80">
            <template slot-scope="scope">
              <dictname category="loud_cluefrom" :v="scope.row.cluefrom" />
            </template>
          </el-table-column>

          <el-table-column prop="expectConvertDate" label="报单日期" :formatter="formatDate" width="110">
          </el-table-column>
          <el-table-column prop="cuname" label="报单人" :show-overflow-tooltip="true" width="80">
          </el-table-column>
          <el-table-column prop="customerChannel" label="渠道" width="80" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <dictname category="sales_region" :v="scope.row.customerChannel" />
            </template>
          </el-table-column>
          <el-table-column prop="areaName" label="区域" width="80" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="province" label="销售区域" width="80" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="city" label="销售地市" width="100">
          </el-table-column>

          <el-table-column prop="probjectSorts" label="订单分类" width="110" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <dictname category="message_type" :v="scope.row.probjectSorts" />
            </template>
          </el-table-column>
          <el-table-column prop="chanceTypeName" label="机会分类" width="110" :show-overflow-tooltip="true">

          </el-table-column>

          <el-table-column prop="projectName" label="项目名称" :show-overflow-tooltip="true" width="150">
          </el-table-column>

          <el-table-column prop="agentName" label="对阵签约经销商" :show-overflow-tooltip="true" width="150">
          </el-table-column>

          <el-table-column prop="salesman" label="销售人员" :show-overflow-tooltip="true" width="150">
          </el-table-column>
          <el-table-column prop="customerName" label="用户单位" :show-overflow-tooltip="true" width="150">
          </el-table-column>
          <el-table-column prop="toAddress" label="收货地址" :show-overflow-tooltip="true" width="150">
          </el-table-column>
          <el-table-column prop="deptName" label="科室" width="110">
          </el-table-column>
          <el-table-column prop="chargePerson" label="联系人/负责人" width="112">
          </el-table-column>
          <el-table-column prop="phone" label="电话" width="110">
          </el-table-column>

          <el-table-column prop="xsyb_lianqun" label="链群" width="110" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <dictname category="xsyb_lianqun" :v="scope.row.lianqun" />
            </template>
          </el-table-column>
          <el-table-column prop="scenesType" label="场景" width="80">
            <template slot-scope="scope">
              <dictname category="loud_scene" :v="scope.row.scenesType"></dictname>
            </template>
          </el-table-column>

          <el-table-column prop="nosignProcode" label="非标产品型号" width="105">
            <template slot-scope="scope">
              <dictname category="crm_changjing_type" :v="scope.row.nosignProcode"></dictname>
            </template>
          </el-table-column>

          <el-table-column prop="proModel" label="产品型号" :show-overflow-tooltip="true" width="150">
          </el-table-column>
          <el-table-column prop="proType" label="产品类型" :show-overflow-tooltip="true" width="100">
          </el-table-column>
          <el-table-column prop="proLevelOne" label="产品大类" :show-overflow-tooltip="true" width="150">
          </el-table-column>
          <el-table-column prop="proLevelTwo" label="产品中类" :show-overflow-tooltip="true" width="150">
          </el-table-column>

          <el-table-column prop="num" label="数量" width="110">
          </el-table-column>
          <el-table-column prop="price" label="价格（万）" width="150">
          </el-table-column>
          <el-table-column prop="totalPrice" label="金额合计" width="110">
          </el-table-column>
          <el-table-column prop="income" label="收入" width="110">
          </el-table-column>
          <el-table-column prop="residueNum" label="剩余数量" width="110">
          </el-table-column>
          <el-table-column prop="estimatedAmount" label="预估金额" width="110">
          </el-table-column>
          <el-table-column prop="statusR" label="节点(项目状态)" width="110" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <dictname v-if="!(scope.row.bidResult == null && scope.row.statusR =='X4')" category="xinxi_jiedian_all" :v="scope.row.statusR" />
              <div>
                <span v-if="scope.row.bidResult == null && scope.row.statusR =='X4'">待签约</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="expOnlineDate" label="预计下单时间" :formatter="formatDate" width="110">
          </el-table-column>
          <el-table-column prop="weekInfos" label="周" width="50">
          </el-table-column>
          <el-table-column prop="expConvDate" label="预计转化时间" :formatter="formatDate" width="110">
          </el-table-column>
          <el-table-column prop="documentaryType" label="跟单商类别" width="110" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <dictname category="gendanshang" :v="scope.row.documentaryType" />
            </template>
          </el-table-column>
          <!--    新加字段      -->
          <el-table-column prop="sapCode" label="关联订单号" width="110">
          </el-table-column>
          <el-table-column prop="orderstotalprice" label="关联订单总额" width="110">
          </el-table-column>
          <el-table-column prop="orderNumber" label="关联订单数量" width="110">
          </el-table-column>

          <el-table-column prop="status" label="漏斗状态" width="120px">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.status == '' || scope.row.status == null || scope.row.status == 0 ">正常</span>
                <!--                <span v-if="scope.row.status == 0">正常</span>-->
                <span v-if="scope.row.status == 1">审批中</span>
                <span v-if="scope.row.status == 2">驳回审批</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="partner" label="合伙人名称" width="110">
          </el-table-column>
          <el-table-column prop="packageName" label="套餐名称" width="200">
          </el-table-column>
          <el-table-column prop="packageCode" label="套餐编码" width="110">
          </el-table-column>
          <el-table-column prop="reason" label="项目关闭原因" width="110">
          </el-table-column>
          <el-table-column prop="note" label="说明" width="110">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="145">
            <template slot-scope="scope">
              <div class="w-caozuo" style="text-align: left;">
                <el-button type="text" size="small" v-if="scope.row.cluefrom == 1 || scope.row.cluefrom == 2 || scope.row.cluefrom == 3" class="h-tableLink h-btn" @click="updateDetail(scope.row)">编辑

                </el-button>

                <el-button type="text" size="small" v-if="scope.row.cluefrom != 1 && scope.row.cluefrom != 2 && scope.row.cluefrom != 3" class="h-tableLink h-btn" @click="updateDetailxs(scope.row.id)">编辑

                </el-button>
                <!--
                <el-button
                        type="text"
                        size="small"
                        v-if="scope.row.cluefrom != 1 && scope.row.cluefrom != 2 && scope.row.cluefrom != 3"
                        class="h-tableLink h-btn"
                        @click="contentdetails(scope.row)"
                >协同

                </el-button>
-->

                <el-button type="text" size="small" v-if="scope.row.cluefrom != 1 && scope.row.cluefrom != 2 && scope.row.cluefrom != 3" class="h-tableLink h-btn" @click="selectContentdetails(scope.row.id)">协同记录

                </el-button>

                <el-button type="text" size="small" class="h-tableLink h-btn" @click="updateDetail(scope.row)" v-show="scope.row.status == 3 && _user.usercode == scope.row.cucode">重新提交
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="h-tableB h-mrt30">
        <pagination :page="q" @query="query" />
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid" />
        <div style="display:flex;align-items: center;">
          <!--         <el-button :disabled="this.multipleSelection.length === 0" class="h-btn h-formBtn h-bgblueQ"
                     icon="h-el-icon h-el-icon-delete" @click="deleteSelete">批量删除
          </el-button>-->
          <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-if="daochuFlag" @click="exportExcel">批量导出
          </el-button>
          <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" @click="uploaddownexcelflagbtn">批量导入
          </el-button>
          <el-button el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="selectSalesman">销售人员修改(批量)
          </el-button>
          <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag" clsname="loudMainSaveExcel" :startrow="2" @callback="uploadExcelFilecallback" />
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="updateSalesmanDialog" class="h-dialog2">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>修改销售人员</h1>
          </div>
        </div>
      </div>
      <div class="h-formLines">
        <div style="padding: 20px;" class="dialogout X-dai">
          <el-form label-position="right" :inline="true" label-width="130">
            <el-form-item label="原始销售人员">
              <el-input v-model="updateSalesman.oldSalesmanName" readonly></el-input>
            </el-form-item>
            <el-form-item label="销售人员" prop="salesmanName" style="margin-left: 40px">
              <el-select v-model="updateSalesman.salesmanName" @change="salesmanSelectChange($event)" remote filterable :filter-method="selectSalesmanLikeName" clearable placeholder="请输入" :remote-method="selectSalesmanLikeName">
                <el-option v-if="updateSalesman.salesmans" v-for="item in updateSalesman.salesmans" :key="item.id" :value="item.userName" :label="item.userName+'('+item.area+' '+item.userCode+')'">

                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div style="display:flex;justify-content:center;margin-bottom:20px">
          <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="batchUpdateSalesman()">修改</el-button>
        </div>
      </div>

    </el-dialog>
    <!-- 新建弹出层-->
    <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="newDialog" class="h-dialog2" width="62%">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>终端录入（原新建漏斗）</h1>
          </div>
        </div>
      </div>
      <div class="h-formLines">
        <div style="padding: 12px;" class="dialogout X-dai">
          <el-form :model="add" label-position="right" :inline="true" label-width="130" :rules="editFormRules" class="demo-ruleForm h-formbLine h-formbnpm Line1">

            <el-form-item label="区域" prop="areaCode" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
              <brselect category="show_area" v-model="add.areaCode" :v="add.areaCode" :clearable="true" :disabled="this.disabled" @change="matchsalesman($event)"></brselect>
            </el-form-item>

            <el-form-item label="销售人员" prop="salesman">
              <el-select v-model="this.salesman" @change="salesmanChange($event)" :disabled="this.disabled" placeholder="销售人员" style="width: 100%;" filterable allow-create default-first-option clearable>
                <el-option v-for="item in salesmanList" :key="item.id" :label="item.userName" :value="item.userName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="机会分类" prop='chanceType'>
              <el-select v-model="add.chanceType" :v="add.chanceType" :disabled="this.disabled" :clearable="true" @change="upchanceType($event)">
                <el-option v-for="(item) in add.xiangmu" :key="item.code" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户单位" prop="customerName">
              <el-select v-model="add.customerName" remote filterable :filter-method="showGroupList" :clearable="true" style="width: 134px;" placeholder="请输入" :remote-method="showGroupList" @change="showGroupList" :disabled="this.disabled">
                <el-option v-for="(item,index) in customerNameList" :key="index" :label="item.deptName" :value="item.deptName">
                </el-option>
              </el-select>
              <i class="el-icon-circle-plus" @click="createAddress"></i>
            </el-form-item>
            <el-form-item label="项目名称" prop='projectName'>
              <el-input v-model="add.projectName" placeholder="请输入" :disabled="this.disabled">
              </el-input>
            </el-form-item>

            <el-form-item label="订单分类" prop='probjectSorts' v-if="this.add.chanceType != 'xinxibaobei'">
              <brselect category="message_type_loud" v-model="add.probjectSorts" :v="add.probjectSorts" :clearable="true" :disabled="this.disabled" />
            </el-form-item>

            <el-form-item label="跟单商类别" prop='documentaryType'>
              <brselect category="gendanshang" v-model="add.documentaryType" :v="add.documentaryType" :clearable="true" :disabled="this.disabled" @change="entrypartner" />
            </el-form-item>

            <el-form-item v-if="add.documentaryType == 2" label="合作人名称" prop='partner'>
              <el-input v-model="add.partner" :disabled="this.disabled">
              </el-input>
            </el-form-item>

            <el-form-item label="签约经销商" prop="agentName" v-if="add.documentaryType == 1">
              <el-select v-model="add.agentName" remote filterable :filter-method="showComList" clearable placeholder="请输入" :remote-method="showComList" @change="showComList" :disabled="this.disabled">
                <el-option v-for="(item,i) in agentList" :key="item.customerName1+i" :label="item.customerName1" :value="item.customerName1">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="销售区域" prop="province" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
              <el-select v-model="add.province" filterable clearable @change="handleItemChange1($event)" :disabled="this.disabled" placeholder="省" style="width: 68%;">
                <el-option v-for="item in add.shenglist" :key="item.value" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="销售地市" prop="city" :rules="[{ required: true, message: '请输入市', trigger: 'change'},]">
              <el-select v-model="this.city" filterable clearable @change="handleItemChange2($event)" :disabled="this.disabled" :rules="[{ required: true, message: '请输入市', trigger: 'change'},]" placeholder="市" style="width: 80%;">
                <el-option v-for="item in cityList" :key="item.name" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="渠道" prop='customerChannel'>
              <el-select v-model="add.customerChannel" @change="changeChannelLoud" :disabled="this.disabled" style="width: 100%;" allow-create default-first-option clearable>
                <el-option v-for="item in chanlList" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>

            <!-- <el-form-item label="收货地址" readonly prop="toAddress">
              <el-input clearable v-model="add.toAddress" readonly style="width:100%;" :disabled="this.disabled">
                <i class="el-icon-search el-input__icon" slot="suffix" @click="selectAreadialog">
                </i>
              </el-input>
            </el-form-item> -->

            <!-- <el-form-item label="部门/科室" prop='deptName'>
              <el-input v-model="add.deptName" :disabled="this.disabled">
              </el-input>
            </el-form-item> -->

            <!-- <el-form-item label="联系人/负责人" prop="chargePerson">
              <el-select v-model="add.chargePerson" @change="showCarryPerson" style="width: 100%;" filterable allow-create default-first-option :disabled="disabled == true" clearable>
                <el-option v-for="item in bscLoudDeptPeople" :key="item.contactPerson" :label="item.contactPerson" :value="item.contactPerson">
                </el-option>
              </el-select>
            </el-form-item> -->

            <!-- <el-form-item label="电话" prop='phone'>
              <el-input v-model="add.phone" onkeyup="value=value.replace(/[^\d]/g,'')" :disabled="this.disabled">
              </el-input>
            </el-form-item> -->

            <el-form-item label="场景" prop='scenesType'>
              <brselect category="loud_scene" v-model="add.scenesType" :v="add.scenesType" :clearable="true" @change="changeScenesType" :disabled="this.disabled" />
            </el-form-item>

            <el-form-item label="节点" prop='statusR'>
              <brselect category="xinxi_jiedian" v-model="add.statusR" :v="add.statusR" :clearable="true" />
            </el-form-item>

            <!-- <el-form-item label="成单率" prop='childMsgId'>
              <brselect category="xinxi_jiedian_zijiedian" v-model="add.childMsgId" :v="add.childMsgId" :disabled="disabled == true" :clearable="true" />
            </el-form-item> -->

            <el-form-item label="预计下单时间" prop='expOnlineDate' v-if="this.add.probjectSorts == 'bhdd'">
              <el-date-picker v-model="add.expOnlineDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :disabled="this.disabled" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>

            <!-- <el-form-item label="预计转化时间" :required="true">
              <el-date-picker v-model="add.expConvDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </el-form-item> -->
            <el-form-item label="套餐">
              <el-select class="ljjsales" v-model="add.packageCode" filterable clearable :disabled="this.disabled" placeholder="请选择" @change="showpackpromode($event)">
                <el-option v-for="item in mealList" :key="item.packageCode" :label="`场景：${item.sceneName}，套餐名称：${item.packageName}，套餐编码：${item.packageCode}，套餐价格：${item.packagePrice}`" :value="item.packageCode" style="color: #999999; font-size: 10px">
                </el-option>
              </el-select>
            </el-form-item>
            <div>
              <el-button @click="addProduct()" type="text" size="mini" :disabled="disabled == true" style="float:right;font-size:20px;margin-right: -5px" icon="el-icon-circle-plus" circle></el-button>
              <div v-for="(listIt, index) in add.products" :key="index" class="h-formBox">
                <el-button @click="deleteProduct(index)" v-show="index != 0" type="text" :disabled="disabled == true" style="float:right;font-size:20px;margin-right: -5px;color:crimson;" size="mini" icon="el-icon-remove" circle></el-button>

                <el-form-item label="链群" prop="lianqun">
                  <el-select @change="changeLianqun($event,index)" v-model="add.products[index].lianqun" :disabled="disabled == true" placeholder="请选择" :v="add.products[index].lianqun" :clearable="true">
                    <el-option v-for="item in lianqunList" :key="item.code" :label="item.name" :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>

                <!--
                <el-form-item label="链群" prop='lianqun' style="margin-left: -15px; margin-right: -15px">
                  <brselect category="xsyb_lianqun" v-model="add.products[index].lianqun"
                            @change="changeLianqun($event,index)"
                            :v="add.products[index].lianqun" :clearable="true"/>
                </el-form-item>
-->
                <el-form-item label="产品型号" v-if="(add.scenesType != null && add.scenesType == 1 ) || ( add.scenesType == 2 && add.statusR == 'R6')">
                  <el-select v-model="add.products[index].proModel" :title="add.products[index].proModel" remoten :disabled="disabled == true" filterable placeholder="请输入" @change="changeProducts($event,index)" :clearable="true">
                    <el-option v-for="(item) in add.productByNameList" :key="item.proModel+'-'+item.proCode+index+'-'+item.area+'-'+item.field" :label="item.proModel+'-'+item.proCode" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="产品型号" v-if="(add.scenesType != null && add.scenesType == 1 && add.documentaryType == 2) || ( add.scenesType == 2 && add.statusR == 'R6' && add.documentaryType == 2)">
                  <el-select v-model="add.products[index].proModel" :title="add.products[index].proModel" remoten :disabled="disabled == true" filterable :filter-method="showProductByNameList" placeholder="请输入" :remote-method="showProductByNameList" @change="changeProducts($event,index)" :clearable="true">
                    <el-option v-for="(item) in add.productByNameList" :key="item.proModel" :label="item.proModel+'-'+item.proCode" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="产品型号" v-if="add.scenesType != null && add.scenesType == 2 && add.statusR != 'R6'">
                  <brselect category="crm_changjing_type" v-model="add.products[index].nosignProcode" :readonly="disabled == true" :v="add.products[index].nosignProcode" :clearable="true" />
                </el-form-item>
                <el-form-item label="金额">
                  <el-input v-model="add.products[index].price" remote oninput="value=value.replace(/[^\d.]/g,'')" :readonly="disabled == true">
                  </el-input>
                </el-form-item>
                <el-form-item label="数量" prop="grabBill">
                  <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="add.products[index].num" :readonly="disabled == true"></el-input>
                </el-form-item>
              </div>
            </div>
          </el-form>

        </div>
        <div style="display:flex;justify-content:center;margin-bottom:20px">
          <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
          <el-button v-if="!this.add.id" class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
          <el-button v-if="this.add.id" class="h-btn h-bBtn h-bgblueQ2" @click="commitUpdate()">修改</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新建用户单位 -->
    <el-dialog :close-on-click-modal="false" @close='closeDialogUser' :visible.sync="institutionalX" class="h-dialog2">
      <companyName ref="companyName" :titleName="titleDig" :add1="addUser" :stVal="stVal" @getChildValue="closeCompanyName"></companyName>
    </el-dialog>
    <!--    <el-dialog :close-on-click-modal="false" @close='closeDialogUser' :visible.sync="newDialogUser" class="h-dialog2">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>{{ titleDig }}</h1>
          </div>
        </div>
      </div>
      <div class="h-formLines">
&lt;!&ndash;        <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">单位名称为大学时，请按实际情况维护用户分类(211/985)</h6>&ndash;&gt;
        <el-form ref="form" :model="addUser" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
          <el-form-item label="单位名称" class="h-elformWrap-2" label-width="100" prop="deptName"
                        :rules="[{ required: true, message: '请输入单位名称', trigger: 'blur'},]">
            <el-select v-model="addUser.deptName" remote filterable :filter-method="selectDept" clearable
                       placeholder="请输入" allow-create filterable
                       :remote-method="selectDept" @change="changeDeptName($event)">
              <el-option v-for="(item) in deptNameList"
                         :key="item.deptName"
                         :label="item.deptName"
                         :value="item.deptName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="渠道" class="h-elformWrap-2" label-width="100" prop="deptSourceChannel"
                        :rules="[{ required: true, message: '请选择渠道', trigger: 'blur'},]">
            <brselect category="sales_region" :v="addUser.deptSourceChannel" @change="changeChannel($event)" :showcode="true"
                      v-model="addUser.deptSourceChannel" clearable></brselect>
          </el-form-item>
          <el-form-item  label="用户分类" class="h-elformWrap-2" label-width="100" prop="schoolTypeName" :rules="[{ required: true, message: '请输入用户分类', trigger: 'change'},]">
            <el-select v-model="addUser.schoolTypeName"
                       @change="changeSchoolType($event)"  placeholder="请选择" clearable>
              <el-option v-for="item in addressTypeList"
                         :key="item.id"
                         :label="item.userUnit"
                         :value="item.userUnit">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="省" class="h-elformWrap-2" prop="province"
                        :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
            <el-select v-model="addUser.province" @change="handleItemChanges1" placeholder="省" style="width: 68%;">
              <el-option
                  v-for="item in shenglists"
                  :key="item.value"
                  :label="item.name"
                  :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="市" class="h-elformWrap-2" prop="city"
                        :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
            <el-select v-model="addUser.city" @change="handleItemChanges2"
                       :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                       placeholder="市" style="width: 68%;">
              <el-option
                  v-for="item in arealists2"
                  :key="item.value"
                  :label="item.name"
                  :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区" class="h-elformWrap-2" prop="area"
                        :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
            <el-select v-model="addUser.area"
                       :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                       placeholder="区" style="width: 68%;" @change="handleItemChange3">
              <el-option
                  v-for="item in arealists3"
                  :key="item.value"
                  :label="item.name"
                  :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="父级" class="h-elformWrap-1" label-width="100" prop="deptName">
            <treeselect
                :multiple="false"
                :options="options"
                :flat="true"
                :default-expand-level="1"
                placeholder="请选择"
                v-model="stVal"
            />
            <treeselect-value :value="stVal"/>
          </el-form-item>
          <el-form-item label="详细地址" class="h-elformWrap-1"
                        :rules="[
                        { required: true, message: '必须输入选项', trigger: 'blur'},
                        {  max: 30, message: '长度在30个字符以内', trigger: 'blur' }
                    ]"
                        prop="address">
            <el-input v-model="addUser.address" style="width: 84%;"></el-input>
          </el-form-item>
        </el-form>
        <div style="display:flex;justify-content:center;margin-bottom:20px">
          <el-button class="h-btn h-bBtn h-bgwhite" @click="exitUser">取消</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreateUser()">提交</el-button>
        </div>
      </div>
    </el-dialog>-->

    <!--协同记录弹出框-->
    <el-dialog :close-on-click-modal="false" @close='closeContentdetails' :visible.sync="contentdetailsDialog" class="h-dialog2">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>协同记录</h1>
          </div>
        </div>
      </div>
      <div style="padding-top: 12px;">
        <template>
          <el-table :data="loudcontenttable" border style="width: 100%">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column prop="cdate" :show-overflow-tooltip="true" label="申请时间" width="150"></el-table-column>
            <el-table-column prop="cucode" :show-overflow-tooltip="true" label="申请人名称" width="120"> </el-table-column>
            <el-table-column prop="cuname" :show-overflow-tooltip="true" label="申请人编码" width="120"> </el-table-column>
            <el-table-column prop="contentMsg" :show-overflow-tooltip="true" label="申请协同内容" width="100"></el-table-column>
            <el-table-column prop="loudStatusR" label="协同漏斗节点" width="105">
              <template slot-scope="scope">
                <dictname category="xinxi_jiedian_all" :v="scope.row.loudStatusR"></dictname>
              </template>
            </el-table-column>
            <el-table-column prop="contentName" :show-overflow-tooltip="true" label="协同人名称" width="120"> </el-table-column>
            <el-table-column prop="contentCode" :show-overflow-tooltip="true" label="协同人编码" width="120"> </el-table-column>
            <el-table-column prop="result" :show-overflow-tooltip="true" label="协同承接结果" width="100"></el-table-column>
            <el-table-column prop="reason" :show-overflow-tooltip="true" label="协同承接答复" width="100"></el-table-column>
            <el-table-column prop="ldate" label="处理时间" width="150"></el-table-column>
            <el-table-column prop="isTimeOut" :show-overflow-tooltip="true" label="审批状态" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">正常</span>
                <span v-if="scope.row.status == 2">审批中</span>
                <span v-if="scope.row.status == 3">驳回</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </el-dialog>

    <!--新增信息漏斗协同-->
    <el-dialog :close-on-click-modal="false" :visible.sync="contentdetailsAdd" class="h-dialog2 yonghu" @close="cancelXt()">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>新增协同</h1>
            <p>New</p>
          </div>
        </div>
      </div>
      <div class="h-formLine h-mrb-38">
        <el-form :model="formModel.loudContent" :rules="rules" ref="formRef" inline class="demo-ruleForm h-formbLine h-dialogForm dialogForms" label-width="80px">
          <!-- 表单头部 -->
          <div class="form-header">
            <el-button @click="addXtUser()" type="text" size="mini" icon="el-icon-circle-plus" circle tooltip="添加协同用户"></el-button>
          </div>

          <!-- 循环表单项 -->
          <div v-for="(listIt, index) in formModel.loudContent" :key="`xt-user-${index}-${listIt.contentCode || Date.now()}`" class="h-formBox form-item-wrap">
            <!-- 删除按钮 -->
            <el-button @click="deleteXtUser(index)" v-show="formModel.loudContent.length > 1" type="text" size="mini" icon="el-icon-remove" circle class="delete-btn" tooltip="删除当前行"></el-button>

            <!-- 用户名称 -->
            <el-form-item label="协同人" :prop="`${index}.contentName`" :rules="rules.contentName" class="h-elformWrap-2 form-item">
              <el-select v-model="listIt.contentName" remote filterable :filter-method="(val) => showUserList(val, index)" :remote-method="(val) => showUserList(val, index)" @change="(val) => handleUserChange(val, index)" placeholder="请输入用户名称搜索" clearable ref="usercodeRefs" :disabled="listIt.disabled">
                <el-option v-for="(item, itemIndex) in userList" :key="`user-option-${item.usercode || itemIndex}`" :label="`${item.username}-${item.usercode}`" :value="`${item.username}-${item.usercode}`"></el-option>
              </el-select>
            </el-form-item>

            <!-- 用户编码 -->
            <el-form-item label="工号" class="h-elformWrap-2 form-item">
              <el-input v-model="listIt.contentCode" placeholder="选择用户后自动带出" disabled clearable></el-input>
            </el-form-item>

            <!-- 协同问题 -->
            <el-form-item label="协同问题" :prop="`${index}.contentMsg`" :rules="rules.contentMsg" class="h-elformWrap-1 form-item">
              <el-input v-model="listIt.contentMsg" placeholder="请输入协同问题描述" type="textarea" :rows="3" resize="vertical"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-formBtn h-bgwhite" @click="cancelXt('f')">取消</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ2" @click="insertXt(1)">提交
        </el-button>
      </div>
    </el-dialog>

    <!-- 创建订单弹出框 -->
    <dingdadd :visible.sync="imgflag3" v-if="imgflag3" @imgfalse3="imgflag3=false" :isloud="1" :ddlx="this.ddlx" :louds="this.louds" />
    <!-- 可以下单的漏斗界面 @choseObj 回调函数 -->
    <loud :visible.sync="loud" v-if="loud" @getChildValue="LoudParts" title="选择漏斗" />

    <!--地址信息-->
    <areaSelect :visible.sync="showdizhiflag" v-if="showdizhiflag" @choseObj="choseDizhi" />
  </div>
</template>
<script>
import ss from '@/api/SystemService';
import updownfile from '../../../utils/updownfile';
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel';
import uploaddownexcelbyrole from '../../../components/uploaddown/uploaddownexcelbyrole';
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import _ from "loadsh";
import companyName from "@/components/basic/companyName.vue";
export default {
  components: {
    companyName,
    uploaddownexcel, uploaddownexcelbyrole, Treeselect
  },
  data () {
    return {
      institutionalX: false,
      //查询属性
      q: {
        funnelCode: '',
        proType: '',
        proLevelOne: '',
        proLevelTwo: '',
        cuname: '',
        productType: '',
        customerName: '',
        customerChannel: '',
        probjectSorts: '',
        statusR: '',
        areaCode: '',
        lianqun: '',
        status: '',
        projectName: '',
        salesman: '', // 销售人员
        deptName: '',  // 部门
        pageSize: 10,
        pageNo: 1,
        expOnlineDate: [],
        total: 0,
        date1: null,
        date2: null,
      },
      newDate1: null,
      newDate2: null,
      provinceJson: null,
      city: null,
      salesman: null,
      mealList: [],  //套餐对象集合
      //目标对阵表单
      mubiaoList: {
        customerCode: null, // 用户编码
        customerName: null, // 客户名称
      },
      //表单
      add: {
        xiangmu: [],
        salesman: null, // 销售人
        provinceId: null,
        province: null,
        provinceList: null,
        areaCode: null,  // 目前没有用
        areaName: null,  // 区域/ 省份名称
        shenglist: [],  // 省份 list
        id: null, // 主键ID
        projectId: null, // 项目id
        projectName: null, // 需求名称
        probjectSorts: null, // （CSW城市网，XM大项目，SD散单）
        projectType: null, // 项目类型0内销1外销2采购3展会
        statusR: null, // 节点  R0:方案交互  R1:需求锁定  R2:预算提报  R3:预算批准  R4:招标挂网  R5:转化收入 R6 已转化 R7 已丢标
        expectConvertDate: null, // 报单日期
        customerChannel: null, // 渠道
        city: null,//地市
        customerCode: null, // 用户编码
        customerName: null, // 客户名称
        deptName: null, // 部门/科室
        chargePerson: null, // 负责人
        phone: null, // 电话
        chanceType: null, // 机会分类
        expOnlineDate: null, // 预计挂网时间
        weekInfos: null,// 周
        // brandDate:null, // 中标时间
        expConvDate: null, // 预计转化时间
        documentaryType: null, // 跟单商别（直单/经销商/合伙人）
        partner: null, // 合伙人名称
        partneritem: null,//合伙人名称 临时的
        remark: null, // 备注
        cucode: null, // 创建人编码
        cuname: null, // 创建人名称
        cdate: null, // 创建时间
        lucode: null, // 更新人编码
        ldate: null, // 最后更新时间
        delflag: null, // 可用标志  1: 可用, 0: 不可用
        brandModel: null,
        delReason: null,
        price: null,
        num: null,
        proCode: null,
        scenesType: null,
        updateStatus: null,
        packageCode: null, //套餐编码
        packageName: null,//套餐名称
        products: [{
          lianqun: '',
          price: '',
          proModel: '', //产品型号
          nosignProcode: '', //非标产品型号
          proCode: '',
          factory: '',
          num: null,
          productByNameList: [],
        }],
        lianqun: null,
        status: null,
        productsitem: [], //非标产品型号 临时
        toAddress: '' //收货地址
      },
      // 销售人员修改
      updateSalesman: {
        // 旧销售员名称
        oldSalesmanName: null,
        // 销售人员名称列表
        salesmans: [],
        // 新销售员名称
        salesmanName: null
      },
      salesmanList: [], // 销售人员list
      deptList: [],  //部门list
      cityList: [],
      //table列表
      tableData: [],
      //表格
      multipleSelection: [],
      customerNameList: [],
      bscLoudDeptPeople: [], //负责人 联系人
      agentList: [],
      chanlList: [],
      //操作标志
      optflag: 'save',
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      spanArr: [],
      times: [],
      itemtimes: [],
      expOnlineDateTimes: [],
      probjectSortsList: [],
      productByNameList: [],
      //导入Excel
      uploaddownexcelflag: false,
      newDialog: false,
      updateSalesmanDialog: false,
      showhistory: null,
      instid: '',
      lianqun: '',
      areaList: [],
      userList: [],
      lianqunList: [],
      disabled: false,
      isflag: false,
      products: [{
        lianqun: '',
        grabBill: '',
      }],
      editFormRules: {
        cuname: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        customerChannel: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        city: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        projectName: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        probjectSorts: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        expOnlineDate: [{ required: true, message: '请输入必填项', trigger: 'change' }],
        expConvDate: [{ required: true, message: '请输入必填项', trigger: 'change' }],
        scenesType: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        // area: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        documentaryType: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        agentName: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        statusR: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        lianqun: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        customerName: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        childMsgId: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        salesman: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        chanceType: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        // toAddress: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        // chargePerson: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        // phone: [{required: true, message: '请输入必填项', trigger: 'blur'}],
      },
      addUser: {
        id: '',
        deptName: '',
        deptType: '',
        leader: '',
        phone: '',
        email: '',
        status: '',
        countryId: '',
        country: '',
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        areaId: '',
        landmark: '',
        area: '',
        address: '',
        shengobj: '',
        shiobj: '',
        quobj: '',
        selectId: '',
        subFlag: '',
        deptSourceChannel: '',
        longitude: '',
        latitude: '',
        parentCode: '',
        schoolTypeName: '',
      },
      proSelect: {
        pcode: 0,
        level: 1,
      },

      formModel: {
        loudContent: [
          {
            mainId: null,
            contentName: null,
            contentCode: null,
            funnelCode: null,
            contentMsg: null,//协同信息
            reason: null,//拒绝协同原因
          }
        ],
      },
      rules: {
        contentName: [{ required: true, message: '请选择用户名称', trigger: 'change' }],
        contentMsg: [{ required: true, message: '请输入协同问题', trigger: 'blur' }]
      },
      loudcontenttable: [
        {
          contentName: null,
          contentCode: null,
          funnelCode: null,
          contentMsg: null,//协同信息
          reason: null,//拒绝协同原因

        }
      ],
      deptNameList: [],
      addressTypeList: [],
      shenglists: [],
      arealists2: [],
      arealists3: [],
      options: [],
      stVal: null,
      titleDig: false,
      closeContentdetails: false,
      contentdetailsDialog: false,
      contentdetailsAdd: false,
      newDialogUser: false,
      imgflag3: false,
      daochuFlag: false,
      loud: false,
      louds: [], //订单关联漏斗 漏斗页面传递到订单页面的单条漏斗记录
      loudId: null,
      loudCode: null,
      ddlx: '',
      showdizhiflag: false,   //收货地址
    }
  },
  created () {
    this.setSelectDate();
    this.query();
    this.getParentInfo();
    this.customerChannelList = this.$store.getters.dictlist("sales_region");
    let funcode = this.$route.query.funcode;
    if (funcode != null) {
      this.loadAreas();
      this.bscclueupdate(funcode);
    }
    ss.Dictservice.listbycategory("xsyb_lianqun").then(rd => {
      this.lianqunList = rd;
    })
    if (this.$store.getters.hasRole('SHICHANG_PINGTAI,swyl_admin,swyl_quyujl,swyl_daqujl')) {
      this.daochuFlag = true;
    }
  },
  beforeRouteEnter (to, from, next) {
    if (to.query.funcode != undefined && from.path === "/bsccluemanage") {
      to.meta.keepAlive = false;
    } else {
      to.meta.keepAlive = true;
    }
    next();
  },

  methods: {
    query () {
      if (this.times && this.times.length > 0) {
        this.q.dateS = this.times[0];
        this.q.dateE = this.times[1];
      } else {
        this.q.dateS = "";
        this.q.dateE = "";
      }
      if (this.itemtimes && this.itemtimes.length > 0) {
        this.q.exconvertdateS = this.itemtimes[0];
        this.q.exconvertdateE = this.itemtimes[1];
      } else {
        this.q.exconvertdateS = "";
        this.q.exconvertdateE = "";
      }

      if (this.expOnlineDateTimes && this.expOnlineDateTimes.length > 0) {
        this.q.sExpOnlineDateTime = this.expOnlineDateTimes[0];
        this.q.eExpOnlineDateTime = this.expOnlineDateTimes[1];
      } else {
        this.q.sExpOnlineDateTime = "";
        this.q.eExpOnlineDateTime = ""
      }
      if (this.q.funnelCode) {
        if (this.q.date1 == this.newDate1 && this.q.date1 == this.newDate1) {
          this.q.date1 = null;
          this.q.date2 = null;
        }
      }

      ss.loudnew.selectPage(this.q).then(rd => {
        console.log(this.q);
        for (var i = 0; i < rd.records.length; i++) {
          if (rd.records[i].statusR != 'R5') {
            // rd.records[i].brandDate = null;
          }
        }
        this.tableData = rd.records;
        this.q.total = rd.total || 0;
        this.getSpanArr();
      })
    },
    updateDetail (row) {
      console.log(row)
      this.loadMeal();
      this.newDialog = true;
      this.add = row;
      this.salesman = row.salesman;
      this.$set(this.add, "id", row.id);
      ss.loudnew.getLoudById(row.id).then(rd => {
        //如果存在销售经销商
        if (rd.obj.documentaryType == '1') {
          //获取渠道链群
          if (rd.obj.lianquns.length > 0) {
            this.lianqunList = rd.obj.lianquns;
          }
          if (rd.obj.qudaos.length > 0) {
            this.chanlList = rd.obj.qudaos;
          }
        } else {
          this.chanlList = this.$store.getters.dicts["sales_region"];
        }
        //判断节点
        if ((rd.obj.statusR == 'R5' || rd.obj.statusR == 'R6') && !this.$store.getters.hasRole('swyl_admin,swyl_wanglgly')) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
        this.upmatchsalesman(rd.obj.areaName)
        this.add = rd.obj;
        this.add.products = rd.obj.products;
        this.add.productsitem = this.add.products;
        this.showChanceType(rd.obj, row.id);
        this.getProduct();
        this.loadAreaUpdate(rd.obj.provinceCode, rd.obj.salesman, rd.obj.city, rd.obj.agentCode);
      })
    },

    updateDetailxs (id) {
      var path = '/infoIndex';
      let routeData = this.$router.resolve({ path: path, query: { 'id': id } });
      window.open(routeData.href, '_blank');
    },
    selectContentdetails (row) {
      var data = {
        "mainId": row
      }
      //根据id查询线索跟踪
      ss.loudnew.getLdContentByMainId(data).then(res => {
        this.loudcontenttable = res.records;
      })
      this.contentdetailsDialog = true
    },

    contentdetails (row) {
      console.log(row)
      this.contentdetailsAdd = true;
      this.loudId = row.id;
      this.loudCode = row.funnelCode;
      console.log(this.loudId, this.loudCode);
    },
    cancelXt () {
      this.formModel.loudContent = [
        {
          mainId: null,
          contentName: null,
          contentCode: null,
          funnelCode: null,
          contentMsg: null,//协同信息
          reason: null,//拒绝协同原因
          userList: [],
        }
      ];
      this.contentdetailsAdd = false;
    },
    async bscclueupdate (funcode) {
      this.newDialog = true;
      ss.loudnew.selectByFunCode(funcode).then(rd => {
        this.$set(this.add, "id", rd.obj.id);
        this.add.products = rd.obj.products;
        this.add = rd.obj;
        this.salesman = rd.obj.salesman;
        this.showChanceType(rd.obj, rd.obj.id);
        this.handleItemChangeclue(rd.obj.provinceCode, rd.obj.salesman, rd.obj.city);
        this.add.salesman = rd.obj.salesman;
        this.add.shenglist = this.shenglists;
      })
    },
    handleItemChangeclue (o, salesman, city) {
      console.log(salesman);
      this.city = city;
      if (city == null) {
        this.city = null;
      }
      if (salesman == null) {
        this.salesman = null;
      }
      this.add.provinceList = _.find(this.shenglists, { code: o });

      this.add.province = this.add.provinceList.name;
      ss.Dictservice.getCity({ code: o }).then(rd => {
        this.cityList = rd.zlist;
      })
      ss.UserService.selectUserNamesByAreaName(this.add.province).then(names => {
        console.log(names.obj);
        this.salesmanList = names.obj;
      })

    },
    getSpanArr () {
      this.spanArr = [];
      this.tableData.forEach((item, index) => {
        console.log(item);
        /* this.spanArr[index] = 0;
         if( index + 1 <= this.tableData.length){
             // 重複組
             if(this.tableData[index].id === this.tableData[index + 1].id){

             }
             // 創新組
             else{
                 this.spanArr[index + 1] = 0;
             }
         }*/

        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else {
          if (this.tableData[index].id === this.tableData[index - 1].id) {
            this.spanArr[this.position] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.position = index;
          }
        }
      })
    },
    //新增收货单位
    createAddress () {
      this.titleDig = "新建用户单位"
      this.institutionalX = true
      /*this.loadArea();*/
    },
    closeCompanyName (propData) {
      console.log(propData);
      this.closeDialogUser();
    },
    loadArea (i) {
      let proSelect = {
        pcode: 0,
        level: 1,
      }
      if (this.$store.getters.hasRole('swyl_gndailishang') == true) {
        proSelect = {
          pcode: 0,
          level: 1,
          usercode: this.$store.getters.user.usercode,
        }
      }
      console.log(proSelect)
      ss.Dictservice.arealistLoud(proSelect).then(rd => {
        this.add.shenglist = rd;
        // for(let i = 0; i < this.shenglist.length; i++){
        //     this.shenglist[i].code = this.shenglist[i].code.substring(0,6);
        // }
        console.log("shenglist", rd);
        console.log(this.add.shenglist);
      })
    },
    loadAreaUpdate (o, salesman, city, agentCode) {
      let proSelect = {
        pcode: 0,
        level: 1,
      }
      console.log(proSelect)
      if (agentCode == null || agentCode == '') {
        ss.Dictservice.arealist(proSelect).then(rd => {
          this.add.shenglist = rd;
          // for(let i = 0; i < this.shenglist.length; i++){
          //     this.shenglist[i].code = this.shenglist[i].code.substring(0,6);
          // }
          console.log("shenglist", rd);
          console.log(this.add.shenglist);
        })
      } else {
        let proSelect = {
          pcode: 0,
          level: 1,
          usercode: agentCode,
        }
        console.log(proSelect)
        ss.Dictservice.arealistLoud(proSelect).then(rd => {
          this.add.shenglist = rd;
        })
      }
      this.handleItemChange4(o, salesman, city);
    },
    loadAreas (i) {
      ss.Dictservice.arealistLoud(this.proSelect).then(rd => {
        this.shenglists = rd;
      })
    },
    //选中 区域带出销售人员
    matchsalesman (province) {
      ss.UserService.selectUserloudNamesBydaquAndarea(province.des).then(names => {
        console.log(names.obj);
        this.salesmanList = names.obj;
      })
    },
    upmatchsalesman (area) {
      ss.UserService.selectUserloudNamesBydaquAndarea(area).then(names => {
        this.salesmanList = names.obj;
      })
    },
    // 省份选择器
    handleItemChange1 (o, salesman, city) {
      this.city = city;
      if (city == null) {
        this.city = null;
      }
      this.add.provinceList = _.find(this.add.shenglist, { code: o });
      this.add.province = this.add.provinceList.name;
      this.add.scenesType = '';
      ss.Dictservice.areaTreelistLoud({ code: o }).then(rd => {
        this.cityList = rd.zlist;
      })
      if (this.add.documentaryType == '1') {
        //控制渠道
        let qudao = {
          usercode: this.add.agentCode,
          areaCode: this.add.province,
        }
        ss.OrderMainService.getChannelByAreaLoud(qudao).then(rd => {
          console.log(rd);
          this.chanlList = rd.msg;
          console.log(this.chanlList)
          this.add.customerChannel = '';
        })
      }
    },
    // 省份选择器
    handleItemChange4 (o, salesman, city) {
      this.city = city;
      if (city == null) {
        this.city = null;
      }
      this.add.provinceList = _.find(this.add.shenglist, { code: o });
      this.add.province = this.add.provinceList.name;
      ss.Dictservice.areaTreelist({ code: o }).then(rd => {
        this.cityList = rd.zlist;
      })
      //控制渠道
      let qudao = {
        usercode: this.add.agentCode,
        areaCode: this.add.province,
      }
      ss.OrderMainService.getChannelByAreaLoud(qudao).then(rd => {
        console.log(rd);
        this.chanlList = rd.msg;
        console.log(this.chanlList)
      })
    },
    handleItemChange2 (o) {
      this.add.city = o;
      this.city = o;
    },
    salesmanChange (o) {
      console.log(o);
      this.salesman = o
      this.add.salesman = o;
    },
    handleFilter () {
      this.query();
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    //订单关联漏斗
    LoudParts (flag, obj, ddlx) {
      this.loud = false;
      if (flag == true) {
        this.ddlx = ddlx;
        this.louds = obj;
        this.imgflag3 = true;
      }
    },
    //收货地址 回调函数
    choseDizhi (obj) {
      this.showdizhiflag = false;
      this.add.addressCode = obj.id;
      this.add.areaId = obj.id;
      this.add.toAddress = obj.quobj.namepath;
      if (obj.zhenobj) {
        obj.addrdetail = obj.zhenobj.name + "/" + obj.addrdetail;
      }
      this.add.toAddress = this.add.toAddress + "##" + obj.addrdetail
      this.add.toProvincesCode = obj.shengobj.code;
      this.add.toProvincesName = obj.shengobj.name;
      this.add.toCityCode = obj.shiobj.code;
      this.add.toCityName = obj.shiobj.name;
    },

    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {

      if (column.label != '序号' &&
        column.property != 'lianqun' &&
        column.property != 'proModel' &&
        column.property != 'price' &&
        column.property != 'totalPrice' &&
        column.property != 'num' &&
        column.property != 'proLevelOne' &&
        column.property != 'proLevelTwo' &&
        column.property != 'proLevelThree' &&
        column.property != 'proLevelFour' &&
        column.label != '产品类型' &&
        column.property != 'subNumber' &&
        column.property != 'income' &&
        column.label != '链群' &&
        column.property != 'residueNum' &&
        column.property != 'proState'
      ) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      } else {
        return [1, 1]
      }

    },
    formatDate (row, column) {
      // 获取单元格数据
      let data = row[column.property]
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return this.$util.riQi3(dt);
    },
    collapseChange () {
      this.isScreen = !this.isScreen;
    },
    closeDialog () {
      this.newDialog = false
      this.lianqun = "";
      this.cityList = null;
      //表单
    },
    createNew () {
      this.cleanAdd();
      this.newDialog = true;
      this.disabled = false;
      this.loadArea();
      this.loadMeal();
      this.showChanceType(null);
      //默认赋值 机会分类为日常订单
      if (this.$store.getters.hasRole('swyl_gndailishang') == true || this.$store.getters.hasRole('crm_agent') == true) {
      } else {
        //默认把当前登录人赋值给销售人员 经销商除外
        this.salesman = this.$store.getters.user.username;
        this.add.salesman = this.salesman;


      }
      this.chanlList = this.$store.getters.dicts["sales_region"];
      this.lianqunList = this.$store.getters.dicts["xsyb_lianqun"];
    },
    //查询所有套餐
    loadMeal () {
      var data = {
        agentCode: null,
        packageName: null,
      }
      data.agentCode = localStorage.getItem("userId");
      ss.bom.loadMeal(data).then(rd => {
        this.mealList = rd.obj;
      })
    },
    changeLianqun (value, index) {
      if (value != undefined) {
        this.lianqun = value.code;
      } else {
        this.lianqun = "";
      }
      this.add.products[index].grabBill = '';
      this.add.products[index].proModel = '';
      this.add.products[index].num = '';
      // this.add.products[index].price = '';
      this.$set(this.add.products[index], "price", 0);
      console.log(this.add.products[index]);
    },
    deepCopy (p, c) {
      var c = c || {};
      for (var i in p) {
        if (typeof p[i] === 'object') {
          c[i] = (p[i].constructor === Array) ? [] : {};
          this.deepCopy(p[i], c[i]);
        } else {
          c[i] = p[i];
        }
      }
      return c;
    },
    showChanceType (values, id) {
      this.add.xiangmu = null;
      let chanceTypes = this.$store.getters.dictlist("chance_type_loud");
      let newChanceTypes;
      this.add.xiangmu = this.deepCopy(chanceTypes, newChanceTypes);
      let json = this.add.xiangmu;
      var infos = [];
      for (let i in json) {
        infos.push(json[i])
      }
      this.add.xiangmu = infos;
      var result = false;
      if (values != null) {
        for (let i = 0; i < chanceTypes.length; i++) {
          if (chanceTypes[i].code == values.chanceType) {
            result = true;
            break;
          }
        }
        if (result == false) {
          console.log(values)
          let newXiangmu =
          {
            "category": "chance_type_loud",
            "code": values.chanceType,
            "des": values.chanceTypeName,
            "id": "",
            "name": values.chanceTypeName,
            "pid": "",
            "refid": "",
          }
          this.add.xiangmu.push(newXiangmu);
        }
      }

      if (id == null) {
        this.add.chanceType = '';
      }
    },
    cleanAdd () {
      this.add = {
        xiangmu: [],
        salesman: '',
        id: '', // 主键ID
        projectId: '', // 项目id
        projectName: '', // 需求名称
        probjectSorts: '', // （CSW城市网，XM大项目，SD散单）
        projectType: '', // 项目类型0内销1外销2采购3展会
        statusR: '', // 节点  R0:方案交互  R1:需求锁定  R2:预算提报  R3:预算批准  R4:招标挂网  R5:转化收入 R6 已转化 R7 已丢标
        expectConvertDate: '', // 报单日期
        areaName: '', // 区域
        shenglist: [],// 省份list
        customerChannel: '', // 渠道
        city: '',//地市
        customerCode: '', // 用户编码
        customerName: '', // 客户名称
        deptName: '', // 部门/科室
        chargePerson: '', // 负责人
        phone: '', // 电话
        chanceType: '', // 机会分类
        expOnlineDate: '', // 预计挂网时间
        weekInfos: '', // 周
        // brandDate:null, // 中标时间
        expConvDate: '', // 预计转化时间
        documentaryType: '', // 跟单商别（直单/经销商/合伙人）
        partner: '', // 合伙人名称
        remark: '', // 备注
        cucode: '', // 创建人编码
        cuname: '', // 创建人名称
        cdate: '', // 创建时间
        lucode: '', // 更新人编码
        ldate: '', // 最后更新时间
        delflag: '', // 可用标志  1: 可用, 0: 不可用
        brandModel: '',
        delReason: '',
        price: '',
        num: '',
        products: [{
          lianqun: '',
          grabBill: '',
          proModel: '',
          num: '',
        }],
        lianqun: '',
      },
        this.city = '',
        this.salesman = ''
    },

    commitCreate () {
      var data = this.add
      // if (this.add.statusR == "R5") {
      //     if(this.add.brandDate == "" || this.add.brandDate == null){
      //         this.$msg.msge("节点为R5时,中标时间不能为空!");
      //         return;
      //     }
      // }
      // if (this.add.brandDate != null){
      //   if (this.add.statusR == "R0" || this.add.statusR == "R1" || this.add.statusR == "R2" || this.add.statusR == "R3" || this.add.statusR == "R4"){
      //     this.$msg.msge("填写中标时间后,节点不能为 R0、R1、R2、R3、R4 !");
      //     return;
      //   }
      // }
      ss.loudnew.newSaveOrUpdate(data).then(res => {
        console.log(res)
        if (res.f == true) {
          this.$message({
            type: 'success',
            message: '保存成功!'
          });
          this.handleFilter()
          this.closeDialog()
        } else {
          this.$message.error(res.msg);
        }
      })

    },
    commitUpdate () {
      var data = this.add
      // if (this.add.statusR == "R5") {
      //     if(this.add.brandDate == "" || this.add.brandDate == null){
      //         this.$msg.msge("节点为R5时,中标时间不能为空!");
      //         return;
      //     }
      // }
      // if (this.add.brandDate != null){
      //   if (this.add.statusR == "R0" || this.add.statusR == "R1" || this.add.statusR == "R2" || this.add.statusR == "R3" || this.add.statusR == "R4"){
      //     this.$msg.msge("填写中标时间后,节点不能为 R0、R1、R2、R3、R4 !");
      //     return;
      //   }
      // }
      if (data.packageCode == "") {
        data.packageName = "";
      }
      ss.loudnew.newSaveOrUpdate(data).then(res => {
        console.log(res)
        if (res.f == true) {
          this.$message({
            type: 'success',
            message: '修改成功!'
          });
          this.handleFilter()
          this.closeDialog()
        } else {
          this.$message.error(res.msg);
        }
      })

    },
    deleteProduct (index) {

      this.add.products.splice(index, 1)
    },
    addProduct () {
      this.add.products.push({
        lianqun: '',
        price: '',
        proModel: '',
        proCode: '',
        factory: '',
        num: null,
      })
    },
    formatPrice (row, column) {
      // 获取单元格数据
      let price = row[column.property]
      if (price == null) {
        return null
      }
      return price / 10000;
    },
    //导入Excel
    uploaddownexcelflagbtn () {
      this.uploaddownexcelflag = true;
    },
    uploadExcelFilecallback (rd) {
      this.query();
      this.$msg.msgs(rd.msg);
    },
    //批量导出
    exportExcel () {
      updownfile.down("/api/swyl/v1/loudnew/loudMain/downloadExcel", this.q, "post");
    },
    exit () {
      this.newDialog = false;
      this.updateSalesmanDialog = false;
    },
    deleteSelete () {
      var idlist = [];
      this.multipleSelection.forEach(element => {
        idlist.push(element.id);
      });
      console.log(idlist)
      this.deleteSingle(idlist)
    },
    showComList (value) {
      this.add.customerChannel = "";
      this.add.products = [{
        lianqun: '',
        price: '',
        proModel: '', //产品型号
        nosignProcode: '', //非标产品型号
        proCode: '',
        factory: '',
        num: null,
        productByNameList: [],
      }],
        ss.netApi.selectByUserNameLoud(value).then(res => {
          console.log(res)
          if (res.obj.length == 0) {
            this.lianqunList = this.$store.getters.dicts["xsyb_lianqun"];
            this.chanlList = this.$store.getters.dicts["sales_region"];
          }
          this.agentList = res.obj
          this.add.agentCode = res.obj[0].usercode
          //获取渠道链群
          if (res.obj[0].lianquns.length > 0) {
            this.lianqunList = res.obj[0].lianquns;
          }
          if (res.obj[0].qudaos.length > 0) {
            this.chanlList = res.obj[0].qudaos;
          }
          var usercode = res.obj[0].usercode;
          // if (res.obj.length > 0){
          //   ss.loudnew.getChanl(usercode).then(rd => {
          //     debugger
          //     this.chanlList = rd.msg;
          //   })
          // }
          if (res.obj.length == 1) {
            let proSelect = {
              pcode: 0,
              level: 1,
              usercode: res.obj[0].usercode,
            }
            console.log(proSelect)
            ss.Dictservice.arealistLoud(proSelect).then(rd => {
              this.add.shenglist = rd;
              // for(let i = 0; i < this.shenglist.length; i++){
              //     this.shenglist[i].code = this.shenglist[i].code.substring(0,6);
              // }
              console.log("shenglist", rd);
              console.log(this.add.shenglist);
              this.add.province = '';
              this.add.city = '';
              this.add.scenesType = '';
            })
          }
        })
    },
    entrypartner () {
      console.log(this.add.documentaryType);
      if (this.add.documentaryType == 1 || this.add.documentaryType == 3) {
        this.add.partneritem = this.add.partner;
        this.add.partner = "";
      }
      if (this.add.documentaryType == 2) {
        this.add.partner = this.add.partneritem;
        this.add.agentName = '';
        this.add.partner = "";
      }

      if (this.add.documentaryType == 3) {
        this.add.partner = "";
        this.add.agentName = '';
      }
    },

    //选择地址
    selectAreadialog () {
      this.showdizhiflag = true;
    },

    showGroupList (value) {
      console.log("qasssd78864123");
      ss.MuBiao.getUserLoud(value).then(res => {
        console.log(res, "78864123");
        this.customerNameList = res
        this.add.customerCode = res[0].id
        console.log(res, "res112111111");
        // if(res.length = 1){
        // console.log(res,"res1121333333331");
        // //查询并校验是否在目标对阵用户列表
        // this.mubiaoList.customerName = value;
        // this.mubiaoList.customerCode = value;
        // }
      })

      if (value != '' && value != null) {
        ss.MuBiao.customerCarryPerson(value).then(res => {
          console.log(res)
          this.bscLoudDeptPeople = res.msg;
        })
      } else {
        this.bscLoudDeptPeople = [];
      }
    },
    showpackpromode (ev) {
      var find = this.mealList.find(a => a.packageCode == ev);
      let id = find.id;
      ss.MuBiao.showPackPromode(id).then(res => {
        res.msg.forEach(a => {
          a.proModel = a.promodel;
          a.price = a.proPrice;
          a.proCode = a.prodcode;
          a.packageProductId = a.id;
          a.id = null;
        });
        this.add.products = res.msg;
      })
    },
    showCarryPerson () {
      let chargePerson = this.add.chargePerson;
      if (chargePerson != null) {
        let person = this.bscLoudDeptPeople.find(a => a.contactPerson == chargePerson)
        this.add.phone = person.phone;
      }
    },
    showProductByNameList (value1, index) {
      console.log("value1value1value1", value1, index);
      let value2 = this.lianqun;
      if (value2 == undefined) {
        value2 = ''
      }
      this.add.productByNameList = [];
      ss.netApi.listByModelProduct(value1, value2).then(res => {
        this.add.productByNameList = res.obj
        //进行强制数据渲染
        this.$forceUpdate();
      })
    },
    changeProducts (value, index) {
      console.log("value",value);
      console.log(index);

      this.$set(this.add.products[index], "price", value.price);
      this.add.products[index].proModel = value.proModel
      this.add.products[index].proCode = value.proCode
      this.add.proCode = value.proCode
      this.add.products[index].lianqun = value.lianqun;
      this.add.products[index].factory = value.factory
      console.log(this.add.products[index].proModel, this.add.products[index].proCode, this.add.products[index].lianqun)
    },

    rest () {
      var pageSize = this.q.pageSize;
      var pageNo = this.q.pageNo;
      var total = this.q.total;
      this.q = {
        pageSize: pageSize,
        pageNo: pageNo,
        total: total,
        cuname: '',
        customerName: '',
        customerChannel: '',
        probjectSorts: '',
        statusR: '',
        areaCode: '',
        projectName: '',
      }
    },
    deleteSingle (id) {
      console.log("id", id)
      var data = id
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ss.loudnew.deleteTarget(data).then(res => {
          console.log(res)
          if (res.f == true) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.query()
          } else {
            this.$message.error(res.msg);
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    getDefaultDate () {
      //获取新的时间(2019.4.12）
      let date = new Date()
      //获取当前时间的年份转为字符串
      let year = date.getFullYear().toString()   //'2019'
      //获取月份，由于月份从0开始，此处要加1，判断是否小于10，如果是在字符串前面拼接'0'
      let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()  //'04'
      //获取天，判断是否小于10，如果是在字符串前面拼接'0'
      let da = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()  //'12'
      //字符串拼接，开始时间，结束时间
      let end = year + '-' + month + '-' + this.getLastDate(year, month)  //当天'2019-04-12'
      let beg = year + '-' + month + '-01'   //当月第一天'2019-04-01'
      this.times = [beg, end] //将值设置给插件绑定的数据
    },
    getLastDate (iYear, iMonth) {

      if (iMonth == '02')
        if (!iYear % '04')
          return 29;
        else return 28
      else if (iMonth == '04' || iMonth == '06' || iMonth == '09' || iMonth == 11)
        return 30;
      else return 31;
    },
    // 查询当前所勾选的数据中 是否存在 不相同的
    selectSalesman () {
      var d = [];
      console.log(this.multipleSelection);
      for (let i = 0; i < this.multipleSelection.length; i++) {
        d[i] = this.multipleSelection[i].id;
      }
      var data = { ids: d };
      ss.loudnew.selectSalesmans(data).then(res => {
        console.log(res);
        this.updateSalesman.oldSalesmanName = res.obj;
        this.updateSalesmanDialog = true;
      })
    },
    // 查询销售人员
    selectSalesmanLikeName (data) {
      ss.loudnew.selectSalesmanLikeName(data).then(res => {
        if (res != null) {
          this.updateSalesman.salesmans = res.obj;
        }
      })
    },

    upchanceType(v){
      this.add.probjectSorts = null;
    },

    // 批量修改
    batchUpdateSalesman () {
      var data = this.multipleSelection
      console.log(data);
      this.$confirm("请确定提交修改", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var d = [];
        for (let i = 0; i < this.multipleSelection.length; i++) {
          d[i] = this.multipleSelection[i].id;
        }
        var data = { "ids": d, salesmanName: this.updateSalesman.salesmanName }
        // 提交数据
        ss.loudnew.batchRepairSalesman(data).then(res => {
          if (res.f == true) {
            this.$message({
              type: 'success',
              message: '提交成功!'
            });
            this.handleFilter()
            this.updateSalesmanDialog = false;
            // this.loadArea();
          } else {
            this.$message.error(res.msg);
          }
        })
      })
    },
    salesmanSelectChange (e) {
      console.log(e);
      this.updateSalesman.salesmanName = e;
    },
    approve () {
      var data = this.multipleSelection
      console.log(data)
      this.approves(data);
    },
    approves (data) {
      this.$confirm('请确定提交审批', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ss.loudnew.loudList(data).then(res => {
          console.log(res)
          if (res.f == true) {
            this.$message({
              type: 'success',
              message: '提交成功!'
            });
            this.handleFilter()
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消审批'
        });
      });
    },
    genzongLiuch (v) {
      console.log(v);
      this.instid = v;
      this.showhistory = true;
    },
    //获取单位名称信息
    selectDept (value) {
      ss.nxAddress.getDeptList(value).then(rd => {
        this.deptNameList = rd.msg;
      })
    },
    //省份选择器
    handleItemChanges1 (o) {
      this.addUser.provinceId = o;
      this.address = _.find(this.shenglists, { code: this.addUser.provinceId });
      this.addUser.province = this.address.name;
      ss.Dictservice.areaTreelist({ code: o }).then(rd => {
        console.log("rddddddd", rd.zlist)
        this.addUser.city = '';
        this.addUser.area = '';
        this.arealists2 = rd.zlist;
        this.arealists3 = [];
      })
    },
    handleItemChanges2 (o) {
      this.addUser.cityId = o;
      this.address = _.find(this.arealists2, { code: this.addUser.cityId });
      this.addUser.city = this.address.name;
      this.arealists3 = _.find(this.arealists2, { code: o }).zlist
      console.log("arealist3", this.arealist3)
      this.arealist4 = []
    },
    handleItemChange3 (o) {
      this.addUser.areaId = o;
      this.address = _.find(this.arealists3, { code: this.addUser.areaId });
      this.addUser.area = this.address.name;
    },
    commitCreateUser (v) {
      this.addUser.subFlag = '提交';
      this.addUser.countryId = '156';
      this.addUser.country = '中国';
      this.addUser.provinceId = this.addUser.provinceId.substring(0, 6);
      this.addUser.cityId = this.addUser.cityId.substring(0, 6);
      this.addUser.areaId = this.addUser.areaId.substring(0, 6);
      this.addUser.parentCode = this.stVal;

      var data = this.addUser;
      ss.nxAddress.insertAddress(data).then(rd => {
        this.closeDialogUser();
      })
    },
    //取消
    exitUser () {
      this.closeDialogUser()
    },
    //获取当前登录人创建的所有父级单位
    getParentInfo () {
      ss.nxAddress.getParentInfo().then(rd => {
        this.options = rd.msg;
      })
    },
    //关闭弹窗,清空数据
    closeDialogUser () {
      this.institutionalX = false
      this.newDialogUser = false
      this.updateDialog = false
      this.insertFlag = false
      this.reFlag = false
      //清空数据
      this.addUser.deptName = '';
      this.addUser.deptType = '';
      this.addUser.phone = '';
      this.addUser.leader = '';
      this.addUser.email = '';
      this.addUser.province = '';
      this.addUser.provinceId = '';
      this.addUser.city = '';
      this.addUser.cityId = '';
      this.addUser.area = '';
      this.addUser.areaId = '';
      this.addUser.landmark = '';
      this.addUser.address = '';
      this.addUser.parentCode = '';
      this.addUser.deptSourceChannel = '';
      this.stVal = null;
      this.addUser.schoolTypeName = '';
    },
    imgfalse3 () {
      this.loud = true;
    },
    //渠道改变
    changeChannel (value) {
      console.log("value", value)
      ss.nxAddress.getAddressTypeByChannel(value.code).then(rd => {
        this.addressTypeList = rd.msg;
        this.addUser.schoolTypeName = '';
      })
    },
    changeChannelLoud () {
      this.add.scenesType = '';
      this.add.products = [{
        lianqun: '',
        price: '',
        proModel: '', //产品型号
        nosignProcode: '', //非标产品型号
        proCode: '',
        factory: '',
        num: null,
        productByNameList: [],
      }];
    },
    getProduct () {
      //如果是代理商
      if (this.$store.getters.hasRole('swyl_gndailishang') == true) {
        //如果渠道不为空,场景不为空
        console.log("代理商");
        var data = {};
        data.scenesType = this.add.scenesType
        data.currencyCode = 'CNY'
        //区域特殊判断
        if (this.add.city == '苏州市' || this.add.city == '深圳市' || this.add.city == '赤峰市') {
          data.areaCode = this.add.city
        } else {
          data.areaCode = this.add.province
        }
        data.customerChannel = this.add.customerChannel
        ss.OrderMainService.selectPageByLoud(data).then(rd => {
          this.add.productByNameList = rd.msg
          //进行强制数据渲染
          this.$forceUpdate();
        })
      } else if (this.add.documentaryType == 1) {
        console.log("选择经销商");
        var data = {};
        data.scenesType = this.add.scenesType
        data.currencyCode = 'CNY'
        data.agentCode = this.add.agentCode
        //区域特殊判断
        if (this.add.city == '苏州市' || this.add.city == '深圳市' || this.add.city == '赤峰市') {
          data.areaCode = this.add.city
        } else {
          data.areaCode = this.add.province
        }
        data.customerChannel = this.add.customerChannel
        ss.OrderMainService.selectPageByLoud(data).then(rd => {
          console.log("rdrdrdrdrd", rd);
          this.add.productByNameList = rd.msg
          //进行强制数据渲染
          this.$forceUpdate();
        })
      } else if ((this.add.documentaryType == 2 || this.add.documentaryType == 3) && this.$store.getters.hasRole('swyl_gndailishang')) {
        var data = {};
        data.customerChannel = this.add.customerChannel
        data.scenesType = this.add.scenesType
        data.currencyCode = 'CNY'
        data.agentCode = this.add.agentCode
        //区域特殊判断
        if (this.add.city == '苏州市' || this.add.city == '深圳市' || this.add.city == '赤峰市') {
          data.areaCode = this.add.city
        } else {
          data.areaCode = this.add.province
        }
        data.customerChannel = this.add.customerChannel
        ss.OrderMainService.selectPageByLoud(data).then(rd => {
          console.log("rdrdrdrdrd", rd);
          this.add.productByNameList = rd.msg
          //进行强制数据渲染
          this.$forceUpdate();
        })
      }
    },
    getProductDls () {
      console.log("getProductDls", this.$store.getters.hasRole('swyl_gndailishang'))
      //如果是代理商
      if (this.$store.getters.hasRole('swyl_gndailishang') == true) {
        //如果渠道不为空,场景不为空
        console.log("代理商");
        var data = {};
        data.currencyCode = 'CNY'
        ss.OrderMainService.selectPageByLoud(data).then(rd => {
          this.add.productByNameList = rd.msg
          //进行强制数据渲染
          this.$forceUpdate();
        })
        ss.netApi.selectByUserNameLoud(this.$store.getters.user.username).then(res => {
          console.log(res, "渠道 链群")
          if (res.obj.length == 0) {
            this.lianqunList = this.$store.getters.dicts["xsyb_lianqun"];
            this.chanlList = this.$store.getters.dicts["sales_region"];
          }
          this.agentList = res.obj
          this.add.agentCode = res.obj[0].usercode
          //获取渠道链群
          if (res.obj[0].lianquns.length > 0) {
            this.lianqunList = res.obj[0].lianquns;
          }
          if (res.obj[0].qudaos.length > 0) {
            this.chanlList = res.obj[0].qudaos;
          }
        })
      }
    },
    showUserList (value, index) {
      console.log('搜索关键词：', value, '当前行索引：', index);
      // 清空用户列表
      this.userList = [];

      // 空值判断：无搜索值时直接返回，避免无效请求
      if (!value) return;

      // 调用接口获取用户列表
      ss.MuBiao.selectUser(value).then(res => {
        console.log('接口返回数据：', res.obj);
        this.userList = res.obj || []; // 兼容接口返回null/undefined的情况
        // 替换为传统判空逻辑
        var currentSelect = this.$refs.usercodeRefs && this.$refs.usercodeRefs[index];
        if (!currentSelect) return;

        // 获取选中值的label并截取用户编码
        // 同样替换selected的可选链
        var selectedLabel = currentSelect.selected && currentSelect.selected.label;
        if (selectedLabel) {
          var valueCode = selectedLabel.split('-')[1];
          // 匹配用户编码并赋值
          res.obj.forEach(el => {
            if (el.usercode === valueCode) {
              this.formModel.loudContent[index].contentCode = el.usercode;
            }
          });
        }
      }).catch(err => {
        // 增加错误处理，避免接口报错导致页面异常
        console.error('获取用户列表失败：', err);
        this.$message.error('获取用户列表失败，请重试');
      });
    },
    // 处理用户选择变更
    handleUserChange (val, index) {
      if (val) {
        const [username, usercode] = val.split('-');
        this.formModel.loudContent[index].contentCode = usercode || '';
      } else {
        this.formModel.loudContent[index].contentCode = '';
      }
      this.formModel.loudContent[index].mainId = this.loudId;
      this.formModel.loudContent[index].funnelCode = this.loudCode;

      console.log(this.formModel.loudContent)
    },

    addXtUser () {
      this.formModel.loudContent.push({
        contentName: null,
        contentCode: null,
        funnelCode: null,
        contentMsg: null,//协同信息
        reason: null,//拒绝协同原因
        userList: [],
      })
      //进行强制数据渲染
      this.$forceUpdate();
    },
    deleteXtUser (index) {
      this.formModel.loudContent.splice(index, 1)
      //进行强制数据渲染
      this.$forceUpdate();
    },
    insertXt () {
      var data = this.formModel
      ss.loudnew.submitContent(data).then(res => {
        console.log(res)
        if (res.f == true) {
          this.$message({
            type: 'success',
            message: '提交成功!'
          });
          this.handleFilter()
          this.cancelXt()
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    changeSchoolType (value) {
      this.addUser.schoolTypeName = value;
    },
    changeScenesType (value) {
      //如果是标准产品
      if (value.code == 1 && this.add.province == null || value.code == 1 && this.add.province == '') {
        this.$message({
          type: 'error',
          message: '请先选择销售区域和渠道!'
        });
        this.add.scenesType = '';
        return;
      }
      //如果是标准产品
      if (value.code == 1 && this.add.customerChannel == null || value.code == 1 && this.add.customerChannel == '') {
        this.$message({
          type: 'error',
          message: '请先选择销售区域和渠道!'
        });
        this.add.scenesType = '';
        return;
      }
      //如果是江苏和广东
      if (this.add.province == "江苏省" || this.add.province == "广东省") {
        //判断是不是选了销售地市
        if (this.add.city == null || this.add.city == '') {
          this.$message({
            type: 'error',
            message: '请先选择销售地市!'
          });
          return;
        }
      }
      if (value.code == 1) {
        this.getProduct();
      }
      this.add.scenesType = value.code
      //进行强制数据渲染
      this.$forceUpdate();
    },
    changeDeptName (val) {
      console.log("changeDeptName", val)
      //匹配省市区信息
      ss.nxAddress.getAddressByWl(val).then(rd => {
        if (rd.f == true) {
          this.add.provinceId = rd.msg.provinceId;
          this.add.province = rd.msg.province;
          this.add.cityId = rd.msg.cityId;
          this.add.city = rd.msg.city;
          this.add.areaId = rd.msg.areaId;
          this.add.area = rd.msg.area;
          this.add.address = rd.msg.address;
          this.handleItemChangeN(this.add.provinceId);
        }
      })
      //根据单位名称获取关键字
      ss.nxAddressKeywords.matchKeywords(val).then(rd => {
        if (rd.msg != null) {
          this.add.deptSourceChannel = rd.msg.channelCode;
          this.add.schoolTypeName = rd.msg.userUnit;
          this.matchChannel(rd.msg.channelCode)
        }
      })
    },
    matchChannel (value) {
      console.log("value", value)
      ss.nxAddress.getAddressTypeByChannel(value).then(rd => {
        this.addressTypeList = rd.msg;
        // this.add.schoolTypeName = '';
      })
    },
    //地址选择器-新
    handleItemChangeN (o) {
      this.address = _.find(this.shenglist, { code: this.add.provinceId });
      // this.add.province = this.address.name;
      ss.Dictservice.areaTreelist({ code: o }).then(rd => {
        this.arealist2 = rd.zlist;
        this.arealist3 = [];
        this.address = _.find(this.arealist2, { code: this.add.cityId });
        // this.add.city = this.address.name;
        this.arealist3 = _.find(this.arealist2, { code: o }).zlist
      })
    },
    setSelectDate () {
      this.q.date2 = this.timestampToTime(new Date());
      var newDate = new Date();
      this.q.date1 = this.timestampToTime(newDate.getTime() - 365 / 2 * 24 * 60 * 60 * 1000 - 24 * 60 * 60 * 1000);// 默认结束日期
      this.newDate1 = this.q.date1;
      this.newDate2 = this.q.date2;
    },
    // 时间戳转换日期
    timestampToTime (timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear();
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
      let D = date.getDate().toString().padStart(2, 0);
      let h = date.getHours() + ':';
      let m = date.getMinutes() + ':';
      let s = date.getSeconds();
      return Y + '-' + M + '-' + D;//+h+m+s
    },
  }
}
</script>

<style scoped>
/* 兼容 */
:deep(.h-formbLine .el-form-item__label) {
  width: 130px;
}

:deep(.h-formbLine .el-form-item__content) {
  width: 150px;
}

.addPro {
  width: 100%;
  /* display:flex; */
}

.addPro .el-form-item {
  width: 45% !important;
}

.addPro .el-form-item /deep/ .el-form-item__content {
  width: 115px;
}
:deep(.h-dialogImg) {
  background-size: 12.1rem;
  padding-left: 5.02rem;
  border-top-left-radius: 8px;
  margin-bottom: 15px;
}
</style>
